<template>
  <section content-sticky :class="{ step3 }">
    <div class="j j2" data-offset="0" v-if="step3"></div>
    <div content-sticky-body class="stick-body" :style="bodyStyle" :id="id">
      <div class="stick-cover">
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
import { applyRatio, getOffsetTop } from '@/utils';
import responsive from '@/utils/responsive';
export default {
  name: 'StickyIdea',
  components: {},
  data() {
    return {
      bodyStyle: {},
      coverStyle: {},
      stickContainer: null,
      stickBody: null,
      innerList: [],
      fixed: false,
    };
  },
  props: {
    img: { type: String },
    id: { default: '' },
    step3: { type: Boolean, default: false },
  },
  computed: {},
  watch: {
    sv: 'render',
  },
  methods: {
    inner(r) {
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = sv - getOffsetTop(this.$el);
      const h = this.$el.offsetHeight - window.innerHeight;
      
      const sec3offsetTop = this.sec3Content.getBoundingClientRect().top;
      let scrollMoveValue;
      
      if (d < 0 || d > h) {
        scrollMoveValue = 0;
        
        if (d < 0) {
          this.copy.classList.remove('pos-bottom');
        } else if (d > h) {
          this.copy.classList.add('pos-bottom');
        }

        if (this.fixed) {
          this.$el.appendChild(this.stickBody);
          this.fixed = false;
          this.$store.commit('setFix', false);
          this.$emit('fixed', this.fixed);
        }
        
      } else {
        scrollMoveValue = sec3offsetTop + window.scrollY;
        
        if (!this.fixed) {
          this.stickContainer.appendChild(this.stickBody);
          this.fixed = true;
          this.$emit('fixed', this.fixed);
          this.$store.commit('setFix', true);
        }
      }
      
      this.scroll.style.transform = `translateY(${scrollMoveValue}px)`;

      if (d < - window.innerHeight * 2 || d > window.innerHeight * 2) return;
      this.inner(d / h);
    }
  },
  mounted() {
    this.stickContainer = document.querySelector('.stick-container2');
    this.stickBody = this.$el.querySelector('.stick-body');
    this.innerList = this.$el.querySelectorAll('[data-p]');
    this.sec3 = document.querySelector('.sec3');
    this.sec3Content = this.sec3.querySelector('.j');
    this.copy = this.sec3.querySelector('.copy');
    this.scroll = this.sec3.querySelector('.scroll');
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
    this.stickBody.parentNode.removeChild(this.stickBody);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";

[content-sticky-body] {
  .en & {
    .semi-bold;
  }
}

@media (min-width: @screen-md-min) {
  .stick-container2 {
    .block;
    .abs;
  }

  [content-sticky] {
    .j {
      .abs;
      .t(100vh);
    }

    &.step3 {
      .j2 {
        .t(50vh);
      }
    }
  }

  [content-sticky-body] {
    .stick-cover {
      z-index: 1;
      .abs;
      .wf;
      .lt;
    }
  }
}
</style>
